import axios from "axios";
import { authClient } from "@/lib/auth";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const creatorCommunityApi = axios.create({
  baseURL: `${BACKEND_URL}/creator-api`,
  timeout: 30000,
});

let cachedToken = null;
let tokenExpiresAt = 0;
let tokenPromise = null;

export async function getCreatorCommunityToken(force = false) {
  if (!force && cachedToken && Date.now() < tokenExpiresAt - 45000) {
    return cachedToken;
  }

  if (tokenPromise) return tokenPromise;

  tokenPromise = authClient
    .post("/community-bridge/token")
    .then(({ data }) => {
      if (!data?.token) throw new Error("Community bridge token missing");
      cachedToken = data.token;
      tokenExpiresAt = Date.now() + (Number(data.expires_in) || 300) * 1000;
      return cachedToken;
    })
    .catch((err) => {
      cachedToken = null;
      tokenExpiresAt = 0;

      // Allow public community pages to load while logged out.
      if ([401, 403].includes(err?.response?.status)) return null;
      throw err;
    })
    .finally(() => {
      tokenPromise = null;
    });

  return tokenPromise;
}

creatorCommunityApi.interceptors.request.use(async (config) => {
  const token = await getCreatorCommunityToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default creatorCommunityApi;
